import { z } from 'zod'

export const repoTransferInputSchema = z.object({
  repoIds: z.array(z.string()),
  targetTeamId: z.string(),
})

export type Input = z.infer<typeof repoTransferInputSchema>

export const repoTransferOutputSchema = z.object({
  status: z.number(),
  message: z.string(),
})

export type OutputTransferRepository = z.infer<typeof repoTransferOutputSchema>
